import { useEffect } from 'react';

const useHighlightCurrentMenuItem = (basePath = '/', highlightClass = 'current-menu-item') => {
  useEffect(() => {
    const baseUrl = window.location.origin;
    const pathname = window.location.pathname;

    if (pathname === basePath || (pathname.startsWith(`${basePath}`) && pathname !== '/')) {
      const links = document.querySelectorAll(`a[href="${baseUrl}${basePath}"], a[href^="${baseUrl}${basePath}/"]`);

      links.forEach(el => {
        const anchor = el as HTMLAnchorElement;
        const parent = anchor.parentNode;

        if (parent && parent instanceof HTMLElement) {
          parent.classList.add(highlightClass);
        }
      });
    }
  }, [basePath, highlightClass]);
};

export default useHighlightCurrentMenuItem;
